import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

// React Bootstrap
import { Form, Button, Col } from "react-bootstrap";

const FormAñadirImagen = ({ submissionHandler }) => {
  const [validated] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <Form.Group as={Col} xs={12} controlId="description-img-name">
          <Form.Label>{"Nombre de la imagen *"}</Form.Label>
          <Form.Control
            name="name"
            placeholder={"Nombre"}
            type="text"
            isInvalid={errors?.name}
            {...register("name", {
              required: "Este campo es obligatorio",
              maxLength: {
                value: 80,
                message: "El máximo de caracteres es 80",
              },
            })}
          />
          <ErrorMessage errors={errors} name="name" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} controlId="description-img-work">
          <Form.Label>{"Descripción"}</Form.Label>
          <Form.Control
            name="description"
            placeholder={"Descripción"}
            as="textarea"
            type="text"
            isInvalid={errors?.description}
            {...register("description", {
              maxLength: {
                value: 200,
                message: "El máximo de caracteres es 200",
              },
            })}
          />
          <ErrorMessage errors={errors} name="description" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} controlId="file-img-work">
          <Form.Label>{"Imagen *"}</Form.Label>
          <Form.Control name="file" type="file" accept="image/*" isInvalid={errors?.file} {...register("file", { required: "Este campo es obligatorio" })} />
          <ErrorMessage errors={errors} name="file" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className={"w-100"}>
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormAñadirImagen;
